export default __webpack_public_path__ + "static/media/Repressor's Dagger.5f25ca77.jpg";